<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1 class="page-header">Tack för din registrering!</h1>
        <p class="intro">Vi har nu tagit emot din registrering. Vi behandlar den och återkommer inom kort. </p>
        <OrderList
          :data="{title:'Vad behöver du göra för att komma igång med Digitala samlingen?', items: ['Invänta godkännande av registreringen.', 'Underteckna överenskommelse och PUB-avtal', 'Köp licens i Webbutiken. ', 'Lägg till skolor och användare i Digitala samlingen. ']}" />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <p>Har du frågor eller behöver du hjälp med registreringen? <a
          href="https://www.spsm.se/om-oss/kontakta-oss/">Kontakta oss</a></p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8">
        <router-link class="btn btn-light mt-4 float-right" to="/">Tillbaka till Mina organisationer</router-link>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from "@vue/runtime-core";
import { useOrganisationStore } from "@/stores/organisation";
import CtaPanel from "../components/CtaPanel.vue";
import OrderList from "../components/OrderList.vue";

export default defineComponent({

  name: "RegistrationFormConfirm",
  components: {
    CtaPanel,
    OrderList
  },
  setup() {
    const state = reactive({
      orgNumber: null,
      orgNumberExist: true
    });

    const OrganisationStore = useOrganisationStore();

    const validate = (event: any) => {
      state.orgNumber = event.target.value;
      // state.orgNumber = OrganisationStore.getOrgNo();
      // orgNumberExist
    };

    // demo data
    const demoData = {};

    return {
      state,
      validate,
      demoData
    };
  }
});
</script>

<style lang="scss">
</style>